module.exports = __webpack_public_path__ + "img/centrogeo.bdbe4e01.png";